/* ============================================================
   FLEXIBLE BLOCKS — Table of Contents
   ------------------------------------------------------------
   For every .fb-toc on the page:
     1. Scan its scope (closest .fb-page) for heading blocks
        marked data-toc="true".
     2. Respect the "levels to include" setting (H2, or H2+H3).
     3. Use each heading's existing id (headings get a server-side
        slug); generate one only if missing.
     4. Build anchor links (custom label supported via
        data-toc-label), wire smooth-scroll + scrollspy.
   Fully automatic — no manual list entry.
   ============================================================ */
(function () {
  function slugify(str) {
    return (str || 'section')
      .toLowerCase().trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)+/g, '') || 'section';
  }

  function buildToc(toc) {
    var list = toc.querySelector('.fb-toc__list');
    if (!list) return;

    var scope = toc.closest('.fb-page') || document;
    var levels = (toc.getAttribute('data-levels') || 'h2').toLowerCase();
    var wantH3 = levels.indexOf('h3') !== -1;
    var offset = parseInt(toc.getAttribute('data-scroll-offset') || '80', 10);

    var headings = scope.querySelectorAll('.fb-heading[data-toc="true"]');
    var items = [];
    var used = {};

    Array.prototype.forEach.call(headings, function (node) {
      var lvl = (node.getAttribute('data-level') || 'h2').toLowerCase();
      if (lvl !== 'h2' && !(wantH3 && lvl === 'h3')) return;

      if (!node.id) {
        var base = slugify(node.textContent);
        if (used[base] != null) { used[base] += 1; node.id = base + '-' + used[base]; }
        else { used[base] = 0; node.id = base; }
      }

      var label = node.getAttribute('data-toc-label');
      items.push({
        el: node,
        id: node.id,
        level: lvl,
        text: (label && label.trim()) ? label.trim() : node.textContent.trim()
      });
    });

    if (!items.length) { toc.style.display = 'none'; return; }
    toc.style.display = '';

    // Render
    list.innerHTML = '';
    items.forEach(function (it) {
      var li = document.createElement('li');
      li.className = it.level === 'h3' ? 'lvl-3' : 'lvl-2';
      var a = document.createElement('a');
      a.href = '#' + it.id;
      a.textContent = it.text;
      a.setAttribute('data-target', it.id);
      li.appendChild(a);
      list.appendChild(li);
    });

    // Smooth scroll (delegated)
    list.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      var el = document.getElementById(a.getAttribute('data-target'));
      if (!el) return;
      e.preventDefault();
      var y = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
      if (history.replaceState) history.replaceState(null, '', '#' + el.id);
    });

    // Scrollspy
    if ('IntersectionObserver' in window) {
      var linkFor = {};
      Array.prototype.forEach.call(list.querySelectorAll('a'), function (a) {
        linkFor[a.getAttribute('data-target')] = a;
      });
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var active = linkFor[entry.target.id];
          if (!active) return;
          Array.prototype.forEach.call(list.querySelectorAll('a.is-active'), function (x) {
            x.classList.remove('is-active');
          });
          active.classList.add('is-active');
        });
      }, { rootMargin: '-12% 0px -75% 0px', threshold: 0 });
      items.forEach(function (it) { spy.observe(it.el); });
    }
  }

  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('.fb-toc'), buildToc);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  // Rebuild live inside the Shopify theme editor
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:block:select', run);
})();
